import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerProfileJobQueryVariables = Types.Exact<{
  filters: Types.JobFilters;
}>;


export type LearnerProfileJobQuery = { job?: { id: string, status: Types.JobEntityStatusEnum } | null };


export const LearnerProfileJobDocument = /*#__PURE__*/ gql`
    query learnerProfileJob($filters: JobFilters!) {
  job(filters: $filters) {
    ... on JobType {
      id
      status
    }
  }
}
    `;

export function useLearnerProfileJobQuery(options: Omit<Urql.UseQueryArgs<LearnerProfileJobQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerProfileJobQuery, LearnerProfileJobQueryVariables>({ query: LearnerProfileJobDocument, ...options });
};